import { formatMonthString } from '@/utils/reports/chartTableFlatTransformer';

export const npsChartTransformers = ({ response, metadata }) => {
  const {
    lookups: { dt = [] } = {},
    chart = [],
    headers = [],
  } = response || {};

  const { tileKey } = metadata || {};

  // Determine if this is candidate or hiring manager NPS
  const isCandidate = tileKey === 'survey_candidate_nps_chart';

  // Index references
  const candidatePromotersIndex = headers.indexOf('candidate_promoters');
  const candidatePassivesIndex = headers.indexOf('candidate_passives');
  const candidateDetractorsIndex = headers.indexOf('candidate_detractors');

  const hmPromotersIndex = headers.indexOf('hm_promoters');
  const hmPassivesIndex = headers.indexOf('hm_passives');
  const hmDetractorsIndex = headers.indexOf('hm_detractors');

  const series = [];

  const npsData = chart.map((item) => {
    // Pick correct set depending on tileKey
    const promoters = isCandidate
      ? item[candidatePromotersIndex]
      : item[hmPromotersIndex];
    const passives = isCandidate
      ? item[candidatePassivesIndex]
      : item[hmPassivesIndex];
    const detractors = isCandidate
      ? item[candidateDetractorsIndex]
      : item[hmDetractorsIndex];

    const total = (promoters ?? 0) + (passives ?? 0) + (detractors ?? 0);

    if (total === 0) return 0;

    const nps = (promoters / total) * 100 - (detractors / total) * 100;

    return Math.round(nps);
  });

  // Push single series (for area chart)
  series.push({
    name: isCandidate ? 'Candidate NPS' : 'Hiring Manager NPS',
    data: npsData,
    type: 'area',
  });

  const res = {
    categories: dt.map(formatMonthString),
    series,
  };

  return res;
};
